import { RetailerNetworkUserLocationsAndLocationGroupsSectionTab } from './retailer-network-user-details-page.types';

export const DEFAULT_RETAILER_NETWORK_USER_LOCATIONS_AND_GROUPS_TAB = 'locations';
export const RETAILER_NETWORK_USER_LOCATIONS_AND_GROUPS_TABS: RetailerNetworkUserLocationsAndLocationGroupsSectionTab[] =
  ['locations', 'groups'];

export const tabLabelsMap: Record<RetailerNetworkUserLocationsAndLocationGroupsSectionTab, string> =
  {
    locations: 'All Locations',
    groups: 'Location Groups',
  };
